module.exports = __webpack_public_path__ + "img/32ff5b576af70e2fe02b46240bd99a1d.2ed97089.png";